import { SelectMasterTranslator } from 'src/translators/SelectMasterTranslator'
import { RoomSelectMasterEntity, SelectResponse } from 'src/types'

type ToEntityInput = {
  projectId: string
  response: SelectResponse
}
type ToEntitiesInput = {
  projectId: string
  responses: SelectResponse[]
}

export const RoomSelectMasterTranslator = {
  toEntity: ({ response, projectId }: ToEntityInput): RoomSelectMasterEntity => {
    return {
      ...SelectMasterTranslator.toEntityWithOutOptions({
        response,
        projectId,
      }),
      selectMasterId: `${response.selectMasterId}`,
      options: SelectMasterTranslator.toEntityOptions(response),
    }
  },

  toEntities: ({ responses, projectId }: ToEntitiesInput): RoomSelectMasterEntity[] => {
    return responses.map(response => RoomSelectMasterTranslator.toEntity({ response, projectId }))
  },
} as const
